import React from 'react';
import { Route, Switch } from 'react-router';
import './App.css';
import Home from './Pages/index';
//import SignInPage from './Pages/signin'; - I will change this to blogs

function App() {
  React.useEffect(() => {
    document.title = "Kiran | Portfolio"
  })
  return (
    <Switch>
      <Route 
      path = '/' 
      component = {Home} />
    </Switch>
  );
}

export default App;
